module.exports = __webpack_public_path__ + "img/calendar.11ca0032.svg";